import { COLORS } from '../../constants/style/color';
import { Display } from '../../constants/style/common.styled';
import { getShadow, rem } from '../../utils/style';
import styled, { css } from 'styled-components';

interface TagType {
  tagColor?: string;
  variant:
    | 'default'
    | 'default-outline'
    | 'primary'
    | 'primary-outline'
    | 'success'
    | 'success-outline'
    | 'error'
    | 'error-outline'
    | 'error-dark'
    | 'info'
    | 'info-outline'
    | 'custom'
    | 'pink-tag';
}

interface LozengeType {
  variant: 'default' | 'primary' | 'success' | 'error' | 'info';
}

export const TagWrapper = styled(Display)<TagType>`
  padding: ${rem(3)} ${rem(6)};
  width: fit-content;
  border-radius: ${rem(4)};
  border-width: ${rem(1)};
  border-style: solid;
  justify-content: space-between;

  span {
    font-weight: 500;
    color: ${COLORS.Black};
  }

  ${(props) => {
    if (props.variant === 'default') {
      return css`
        background: ${COLORS.OffWhite};
        @include ${getShadow({ variant: 'tag-white' })};
      `;
    }

    if (props.variant === 'default-outline') {
      return css`
        background: ${COLORS.White};
        border-color: ${COLORS.LightGray};
      `;
    }

    if (props.variant === 'primary') {
      return css`
        background: ${COLORS.LightPurple};
        border-color: ${COLORS.LightPurple};

        span {
          color: ${COLORS.Purple};
        }
      `;
    }

    if (props.variant === 'primary-outline') {
      return css`
        background: ${COLORS.White};
        border-color: ${COLORS.Purple};

        span {
          color: ${COLORS.Purple};
        }
      `;
    }

    if (props.variant === 'success') {
      return css`
        border-color: ${COLORS.LightGreen};
        background: ${COLORS.LightGreen};

        span {
          color: ${COLORS.Green};
        }
      `;
    }

    if (props.variant === 'success-outline') {
      return css`
        border-color: ${COLORS.Green};
        border: ${rem(1)} solid ${COLORS.Green};

        span {
          color: ${COLORS.Green};
        }
      `;
    }
    if (props.variant === 'pink-tag') {
      return css`
        background: ${COLORS.LightPink};
        border-color: ${COLORS.LightPink};
        border: ${rem(1)} solid ${COLORS.LightPink};

        span {
          color: ${COLORS.Pink};
        }
      `;
    }

    if (props.variant === 'error') {
      return css`
        border-color: ${COLORS.LightRed};
        background: ${COLORS.LightRed};

        span {
          color: ${COLORS.Red};
        }
      `;
    }

    if (props.variant === 'error-outline') {
      return css`
        border-color: ${COLORS.Red};
        border: ${rem(1)} solid ${COLORS.Red};

        span {
          color: ${COLORS.Red};
        }
      `;
    }

    if (props.variant === 'error-dark') {
      return css`
        border-color: ${COLORS.CulturedWhite};
        border: ${rem(1)} solid ${COLORS.CulturedWhite};
        filter: drop-shadow(0px 1px 2px {COLORS.TagShadow});

        span {
          color: ${COLORS.Red};
        }
      `;
    }

    if (props.variant === 'info') {
      return css`
        border-color: ${COLORS.Magnolia};
        background: ${COLORS.Magnolia};

        span {
          color: ${COLORS.Iris};
        }
      `;
    }

    if (props.variant === 'info-outline') {
      return css`
        border-color: ${COLORS.Iris};
        border: ${rem(1)} solid ${COLORS.Iris};

        span {
          color: ${COLORS.Iris};
        }
      `;
    }

    if (props.variant === 'custom') {
      return css`
        background: ${props?.tagColor};
        border: ${rem(1)} solid ${props?.tagColor};

        span {
          color: #fff !important;
        }
      `;
    }
  }};

  .dot {
    position: relative;
    width: ${rem(4)};
    height: ${rem(4)};
    border-radius: ${rem(4)};
    background: inherit;
    margin-right: ${rem(4)};

    ${(props) => {
      if (props.variant === 'default') {
        return css`
          background: ${COLORS.Gray};
        `;
      }

      if (props.variant === 'default-outline') {
        return css`
          background: ${COLORS.SpanishGray};
        `;
      }

      if (props.variant === 'primary') {
        return css`
          background: ${COLORS.Purple};
        `;
      }

      if (props.variant === 'primary-outline') {
        return css`
          background: ${COLORS.Purple};
        `;
      }

      if (props.variant === 'success') {
        return css`
          background: ${COLORS.Green};
        `;
      }

      if (props.variant === 'success-outline') {
        return css`
          background: ${COLORS.Green};
        `;
      }

      if (props.variant === 'error') {
        return css`
          background: ${COLORS.Red};
        `;
      }

      if (props.variant === 'error-outline') {
        return css`
          background: ${COLORS.Red};
        `;
      }

      if (props.variant === 'info') {
        return css`
          background: ${COLORS.Iris};
        `;
      }

      if (props.variant === 'info-outline') {
        return css`
          background: ${COLORS.Iris};
        `;
      }
    }};
  }
`;

export const LozengeWrapper = styled(Display)<LozengeType>`
  padding: ${rem(4)} ${rem(6)};
  border-radius: ${rem(4)};
  justify-content: space-between;

  span.material-symbols-outlined {
    font-size: ${rem(12)};
    margin-left: ${rem(12)};
    color: ${COLORS.SpanishGray};
    cursor: pointer;

    &.active {
      opacity: 0.5;
    }
  }

  ${(props) => {
    if (props.variant === 'default') {
      return css`
        background: ${COLORS.CulturedWhite};
      `;
    }

    if (props.variant === 'primary') {
      return css`
        background: ${COLORS.LightPurple};
      `;
    }

    if (props.variant === 'success') {
      return css`
        background: ${COLORS.LightGreen};
      `;
    }

    if (props.variant === 'error') {
      return css`
        background: ${COLORS.LightRed};
      `;
    }

    if (props.variant === 'info') {
      return css`
        background: ${COLORS.Magnolia};
      `;
    }
  }};
`;
